import React, { useCallback, useEffect, useRef, useState } from "react";
import ui from "../../pages/dashboard/DashboardUI.module.css";
import styles from "./PageChrome.module.css";
import useClickOutside from "../../hooks/useClickOutside";

// "+ Add" button that opens a small menu of what can be added; items are { label, onClick }.
export default function AddMenu({ items }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const close = useCallback(() => setOpen(false), []);
  useClickOutside(wrapRef, close, open);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && close();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, close]);

  return (
    <div className={styles.addWrap} ref={wrapRef}>
      <button
        type="button"
        className={ui.addButton}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className={ui.icon}>＋</span> Add
      </button>
      {open && (
        <div className={styles.addMenu} role="menu">
          {items.map((item) => (
            <button
              key={item.label}
              type="button"
              className={styles.addMenuItem}
              role="menuitem"
              onClick={() => { close(); item.onClick(); }}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
